import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import { EMPTY, expand, Observable } from 'rxjs';
import { SessionService } from "./session.service";
import { EnvVariableService } from "./env-variable.service";
import { Form } from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private readonly httpClient: HttpClient, 
    private readonly sessionService: SessionService, 
    private readonly envSer: EnvVariableService) 
    {
    }
 
    private readonly ContentType = 'application/json';
  private readonly XContentTypeOptions = "nosniff";
  private readonly XFrameOptions = "DENY";
  private readonly XXSSProtection = "1; mode=block";
  private readonly StrictTransportSecurity = "max-age=31536000; includeSubDomains";
  private readonly ContentSecurityPolicy = "default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval'; style-src 'self' 'unsafe-inline'";
  private readonly ReferrerPolicy = "strict-origin-when-cross-origin";
 
  uploadFormUrl(payload: any): Observable<any> {
    debugger;
    const url =this.envSer.getConfigKey("base_API_url");
    const token : any = sessionStorage.getItem('accessToken');
    const data = { payload};
    return this.httpClient.post<any>(url+'/retrieve', data, {
      headers: new HttpHeaders({
      "Authorization": token,
        "Content-Type": this.ContentType,
        "X-Content-Type-Options": this.XContentTypeOptions,
        "X-Frame-Options": this.XFrameOptions,
        "X-XSS-Protection": this.XXSSProtection,
        "Strict-Transport-Security": this.StrictTransportSecurity,
        "Content-Security-Policy": this.ContentSecurityPolicy,
        "Referrer-Policy": this.ReferrerPolicy
      }),
       responseType: 'text' as 'json',
    });
  }

authCall(): Observable<any> {
    const url =this.envSer.getConfigKey("base_API_url");
    const token : any = sessionStorage.getItem('accessToken');
    const data = ''
    debugger;
    return this.httpClient.post<any>(url+'/roleauth',data, {
      headers: new HttpHeaders({
      "Authorization": token,
        "Content-Type": this.ContentType,
        "X-Content-Type-Options": this.XContentTypeOptions,
        "X-Frame-Options": this.XFrameOptions,
        "X-XSS-Protection": this.XXSSProtection,
        "Strict-Transport-Security": this.StrictTransportSecurity,
        "Content-Security-Policy": this.ContentSecurityPolicy,
        "Referrer-Policy": this.ReferrerPolicy
      })
    });
  }

   requestPresignedUrl(file_name: string, upload_timestamp: string, user_id: string): Observable<{ uploadUrl: string }> {
    const url =this.envSer.getConfigKey("base_API_url");

    const body = {
    file_name : file_name,
     upload_timestamp: upload_timestamp,
      user_id: user_id
    }
    return this.httpClient.post<{ uploadUrl: string }>(url, body);
  }

  uploadToS3(uploadUrl: string, file: File): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Content-Type': 'text/csv',
        "X-Content-Type-Options": this.XContentTypeOptions,
        "X-Frame-Options": this.XFrameOptions,
        "X-XSS-Protection": this.XXSSProtection,
        "Strict-Transport-Security": this.StrictTransportSecurity,
        "Content-Security-Policy": this.ContentSecurityPolicy,
        "Referrer-Policy": this.ReferrerPolicy
    });
    return this.httpClient.put(uploadUrl, file, {
      headers,
      observe: 'response',
    });
  }

  uploadUrl(file_name: string, upload_timestamp: string, user_id: string, hs_region: string, business_type: string): Observable<any> {
    const url =this.envSer.getConfigKey("base_API_url");
    const token : any = 'bearer ' + sessionStorage.getItem('accessToken');
    const data = { file_name,upload_timestamp,user_id,hs_region, business_type};
    return this.httpClient.post<any>(url+'/presignedUrlGen', data, {
      headers: new HttpHeaders({
      "Authorization": token,
        "Content-Type": this.ContentType,
        "X-Content-Type-Options": this.XContentTypeOptions,
        "X-Frame-Options": this.XFrameOptions,
        "X-XSS-Protection": this.XXSSProtection,
        "Strict-Transport-Security": this.StrictTransportSecurity,
        "Content-Security-Policy": this.ContentSecurityPolicy,
        "Referrer-Policy": this.ReferrerPolicy
      })
    });
  }
  dowloadCall(file_name: string, user_id: string, hs_region: string, business_type: string): Observable<any> {
    const url =this.envSer.getConfigKey("base_API_url");
    const token : any = 'bearer ' + sessionStorage.getItem('accessToken');
    const data = { file_name,user_id,hs_region, business_type};
    return this.httpClient.post<any>(url+'/downloadBulkRes', data, {
      headers: new HttpHeaders({
      "Authorization": token,
        "Content-Type": this.ContentType,
        "X-Content-Type-Options": this.XContentTypeOptions,
        "X-Frame-Options": this.XFrameOptions,
        "X-XSS-Protection": this.XXSSProtection,
        "Strict-Transport-Security": this.StrictTransportSecurity,
        "Content-Security-Policy": this.ContentSecurityPolicy,
        "Referrer-Policy": this.ReferrerPolicy
      })
    });
  }
    apiCall( call: string): Observable<any> {
 const url = this.envSer.getConfigKey("base_API_url");
 const token: any = 'bearer ' + sessionStorage.getItem('accessToken');
 // keep track of lastSubCode
 let lastSubCode: any = 0;
 const makeCall = (subCode: any): Observable<any> => {
   const data = {
    //  type: type,
    //  max_seq: subCode
   };
   return this.httpClient.post<any>(`${url}/${call}`, data, {
     headers: new HttpHeaders({
       'Authorization': token,
       'Content-Type': this.ContentType,
        "X-Content-Type-Options": this.XContentTypeOptions,
        "X-Frame-Options": this.XFrameOptions,
        "X-XSS-Protection": this.XXSSProtection,
        "Strict-Transport-Security": this.StrictTransportSecurity,
        "Content-Security-Policy": this.ContentSecurityPolicy,
        "Referrer-Policy": this.ReferrerPolicy
     })
   });
 };
 return makeCall(lastSubCode).pipe(
  expand(response => {
    const details = response?.ref_data?.details;

    if (details?.has_more_data && details?.max_seq !== undefined) {
      return makeCall(details.max_seq);
    }

    return EMPTY;
  })
);
}
}
